import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, BookOpen, Radio, FileText, Award, ShoppingBag, User, Briefcase } from "lucide-react";

const nav = [
  { to: "/learner", label: "Dashboard", icon: LayoutDashboard },
  { to: "/learner/my-courses", label: "My Courses", icon: BookOpen },
  { to: "/learner/live", label: "Live Classes", icon: Radio },
  { to: "/learner/test-series", label: "My Test Series", icon: FileText },
  { to: "/learner/tests", label: "Course Tests", icon: FileText },
  { to: "/learner/results", label: "Results", icon: Award },
  { to: "/learner/orders", label: "Orders", icon: ShoppingBag },
  { to: "/learner/internship", label: "My Internship", icon: Briefcase },
  { to: "/learner/profile", label: "Profile", icon: User },
];

export default function LearnerLayout() {
  return <DashboardLayout nav={nav} title="Learner Portal" />;
}
